// extracted by mini-css-extract-plugin
module.exports = {"block":"Actions_block__TL6en"};